<script setup>
import {ref} from "vue"
import CDialog from "@/Components/CDialog.vue"
import PCartItemsList from "@/Pages/Cart/Partials/PCartItemsList.vue"

const dialog = ref()
const drawer = defineModel()

</script>

<template>
    <v-navigation-drawer
        v-model="drawer"
        temporary
        :location="$vuetify.display.mobile ? 'bottom' : 'right'"
        :width="$vuetify.display.mobile ? null : 600"
        height="100vh"
        style="z-index: 1200; top: 0 !important; bottom: 0 !important; position: fixed !important; height: 100vh !important; max-height: 100vh !important;"
    >
        <p-cart-items-list v-model="drawer"/>
    </v-navigation-drawer>
    <c-dialog ref="dialog"/>
</template>

